module.exports = __webpack_public_path__ + "media/coffeeWindChimes.3634e36c.mp3";